import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=65a326a4&"
import script from "./Submissions.vue?vue&type=script&lang=ts&"
export * from "./Submissions.vue?vue&type=script&lang=ts&"
import style0 from "./Submissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports